import { forwardRef, useId } from 'react';
import { cn } from '@shared/utils';

interface TextareaProps {
  className?: string;
  labelClassName?: string;
  textareaClassName?: string;
  label?: string;
  name?: string;
  placeholder?: string;
  cols?: number;
  rows?: number;
  disabled?: boolean;
  required?: boolean;
  readOnly?: boolean;
  value?: string | number;
  onChange?: (value: string) => void;
  onFocus?: () => void;
  isError?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const id = useId();

  return (
    <div className={cn('flex flex-col gap-2', props.className)}>
      {props.label && (
        <label htmlFor={id} className={cn('block w-fit font-medium text-black select-none max-md:text-[#4c4c4c80]', props.labelClassName)}>
          {props.label}
        </label>
      )}
      <textarea
        ref={ref}
        id={id}
        className={cn(
          'w-full resize-none rounded border-none bg-[#fafafa] max-md:rounded-lg max-md:border max-md:border-[#4c4c4c10]',
          props.textareaClassName,
        )}
        name={props.name}
        cols={props.cols}
        rows={props.rows}
        placeholder={props.placeholder}
        disabled={props.disabled}
        required={props.required}
        readOnly={props.readOnly}
        value={props.value}
        onChange={(e) => props.onChange?.(e.target.value)}
        onFocus={props.onFocus}
      />
    </div>
  );
});
